/**
 * Class to build and render forms
 *
 * @author: Kete Martins
 * Date: 22/11/13
 * Time: 08:59
 */



Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.FilterByManager = (function () {

    function FilterByManager (form) {

        this.filters = {};
        this.values = null;
        this.entityToAction = form.entityToAction;

        this.validate = function (controller) {
            this.rootEl.className = 'filterBySection';
            for (let key in this.filters) {
              var filterBy = this.filters[key];
              var pickListValue = filterBy.filter.getValue();
              if(pickListValue.value.trim() === "" || pickListValue.value.trim() === "[]" ) {
                controller.allow_submit.status = false;
                controller.allow_submit.errorMessages.push(
                    Monet.Form.Messages.mountErrorMessageObject('panel.panelFilter.value: InvalidAttribute'));
                this.rootEl.className += ' control-group error';
              }
            }
        };

        this.setValues = function (values) {
            if (values) {
                this.values = values;
                for (var i = 0, length = values.length; i < length; i++) {
                    var filter = this.generateNewFilterBy();
                    filter.setValue(values[i]);
                }
            }
        };

        this.getFiltersValue = function () {
            var panelFilters = [];
            for (var key in this.filters) {
                var value = this.filters[key].getValue();

                panelFilters.push(value);
            }

            return panelFilters;
        }.bind(this);

        this.generateNewFilterBy = function () {
            var filterUuid = uuid.v1();
            var filterBy = new Greenmile.PanelBuilder.FilterBy(this, filterUuid);
            this.filters[filterUuid] = filterBy;
            this.fieldsContainer.appendChild(filterBy.render());
            filterBy.postRender();

            return filterBy;

        }.bind(this);

        this.getFilterBySection = function () {

            this.rootEl = document.createElement('div');
            this.fieldsContainer = document.createElement('div');

            this.rootEl.className = 'filterBySection';
            this.fieldsContainer.className = 'fieldsContainer';

            this.rootEl.appendChild(form.getTitleSection('Greenmile.PanelBuilder.FilterEditor'));
            this.rootEl.appendChild(this.fieldsContainer);
            this.rootEl.appendChild(Greenmile.PanelBuilder.Utils.getBtnNewItem('PanelBuilder.newFilter', this.generateNewFilterBy));

            return this.rootEl;
        }.bind(this);

    }

    return FilterByManager;

}());
